import * as React from "react"
import { Breadcrumbs } from "../sharedLayout/breadcrumbs"
import { EventTemplate } from "../models/Events/Events"
import { getBreadcrumbsCourseForm } from "./educationFormState"
import { CoursePage } from "../cmsPage/cmsPageState"

type EducationFormHeaderProps = {
  event: EventTemplate
  pageData: CoursePage
}

export const EducationFormHeader = (props: EducationFormHeaderProps) => {
  const { event, pageData } = props
  return <header className="pageheader pageheader--text pageheader--cw">
    <div className="pageheader__inner">
      <div className="pageheader__content container--m gutter--m spacing--m">
        <Breadcrumbs links={getBreadcrumbsCourseForm(pageData).links} />
        <h1 className="pageheader__title title--l">{event.name}</h1>
      </div>
    </div>
  </header>
}
